import React, { memo, useMemo, useRef, useLayoutEffect } from 'react';

function StepContainer({
  totalSteps,
  handlePreviousStep,
  handleNextStep,
  currentStepData,
  stepsData,
  currentStep,
  selectedOptions,
  onOptionSelect,
  collectionId
}) {
  const handleOptionClick = (option) => {
    onOptionSelect(currentStepData.stepName, option);
  };

  const { previousStepName, nextStepName } = useMemo(() => {
    const currentStepIndex = stepsData.findIndex((step) => step.num === currentStep);
    return {
      previousStepName: currentStepIndex > 0 ? stepsData[currentStepIndex - 1].stepName : null,
      nextStepName: currentStepIndex < totalSteps - 1 ? stepsData[currentStepIndex + 1].stepName : null
    };
  }, [currentStep, stepsData, totalSteps]);

  return (
    <div className="relative">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 overflow-y-auto">
        {currentStepData.options.map((option) => (
          <Option
            key={`${option.id}-${option.name}`}
            option={option}
            stepName={currentStepData.stepName}
            isSelected={selectedOptions[currentStepData.stepName]?.id === option.id}
            onClick={() => handleOptionClick(option)}
            collectionId={collectionId}
          />
        ))}
      </div>
      <div className="hidden md:flex justify-between items-center gap-4 mt-6 pt-4 border-t border-gray-200">
        <button 
          className={`px-6 py-3 font-vag text-fluid-lg font-bold rounded-lg transition-all duration-300 ${
            currentStep > 1 
              ? 'bg-purple-600 hover:bg-purple-700 hover:shadow-lg' 
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
          onClick={handlePreviousStep}
          disabled={currentStep <= 1}
        >
          Previous
        </button>
        <button 
          className={`px-6 py-3 font-vag text-fluid-lg font-bold rounded-lg transition-all duration-300 ${
            currentStep < totalSteps 
              ? 'bg-purple-600 hover:bg-purple-700 hover:shadow-lg' 
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
          onClick={handleNextStep}
          disabled={currentStep >= totalSteps}
        >
          Next
        </button>
      </div>
    </div>
  );
}

const Option = memo(({ option, isSelected, onClick, stepName, collectionId }) => (
  <div
    className={`flex flex-col items-center text-center cursor-pointer gap-2 p-2 transition-all duration-300 ${
      isSelected ? 'bg-purple-600' : 'hover:bg-purple-500'
    }`}
    onClick={onClick}
  >
    <div className={`overflow-hidden border-2 transition-all duration-300 ${
      isSelected ? 'border-black opacity-100' : 'border-dashed opacity-40 hover:border-purple-300 hover:opacity-100'
    }`}>
      <img 
        src={require(`../images/${collectionId}/${stepName}/${option.imageName}.png`)} 
        alt={option.name}
        className="w-full h-auto"
      />
    </div>
    <p className={`text-xs font-bold transition-opacity duration-300 ${
      isSelected ? 'opacity-100' : 'opacity-65 hover:opacity-100'
    }`}>
      {option.name}
    </p>
  </div>
));

export default memo(StepContainer);
